<template>
    <div class="content" id="content">

        <toolbar v-bind:selection="toolbar" title="Editar visita" action="eliminar"  />

        <v-text-field
                color="orange"
                label="Número de la colmena/núcleo*"
                v-bind:value="info.number"
                disabled
        ></v-text-field>

        <v-form ref="form" v-model="valid" lazy-validation>

            <p for="date" style="font-size:0.69rem;"><b>Fecha de la visita*</b></p>
            <datepicker
                    style="margin-bottom:20px;"
                    name="date"
                    id="date"
                    v-model="infoform.date"
                    format="dd/MM/yyyy"
                    class="form-datepicker"></datepicker>

            <p class="v-messages__message">{{errors.date}}</p>


            <vigor v-bind:vigor="infoform.vigor" ></vigor>

            <v-slider
                    v-model="infoform.vigor"
                    color="amber darken-2"
                    max="100"
                    min="0"
                    step="5"
            ></v-slider>

            <b>Agresividad</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="cheerup in optionsCheerup" :key="cheerup.value">
                    <input type="radio" v-model="infoform.cheerup" :id="cheerup.value" :value="cheerup.value">
                    <label class="btn" :for="cheerup.value">{{cheerup.text}}</label>
                </div>
            </div>


            <!--v-select
                    v-model="infoform.cheerup"
                    class="form-group"
                    color="orange"
                    :items="optionsCheerup"
                    label="Ánimo"
                    data-vv-name="infoform.cheerup"
            ></v-select-->


            <!--v-select
                    v-model="infoform.conditions"
                    class="form-group"
                    color="orange"
                    :items="optionsConditions"
                    label="Condiciones"
                    data-vv-name="infoform.conditions"
            ></v-select-->

            <b>Condiciones</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="conditions in optionsConditions" :key="conditions.value" style="width:auto;">
                    <input type="radio" v-model="infoform.conditions" :id="conditions.value" :value="conditions.value">
                    <label class="btn" :for="conditions.value">{{conditions.text}}</label>
                </div>
            </div>


            <div class="vsm-header">
                CUADROS DE CRÍA
            </div>

            <div class="row">
                <div class="col-d-8">
                    <b>Cuadros que dejaste en visita anterior</b>
                </div>

                <div class="col-d-4">
                    <v-select
                            v-model="infoform.frame_number_previous_visit"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="frames"
                    ></v-select>
                </div>
            </div>


            <div class="row">
                <div class="col-d-8">
                    <b>Cuadros al iniciar la visita</b>
                </div>

                <div class="col-d-4">
                    <v-select
                            v-model="infoform.frame_with_bee_number"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="frames"
                    ></v-select>
                </div>
            </div>

            <div class="row">
                <div class="col-d-8">
                    <b>Cuadros que dejaste</b>
                </div>

                <div class="col-d-4">
                    <v-select
                            v-model="infoform.frame_number_final"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="frames"
                    ></v-select>
                </div>
            </div>



            <div class="radio-btn-group">
                <div class="radio" v-for="size in optionsSize" :key="size.value" style="width:auto">
                    <input type="radio" v-model="infoform.frame_with_bee_size" :id="size.value" :value="size.value">
                    <label class="btn" :for="size.value">{{size.text}}</label>
                </div>
            </div>



            <b>Reserva Miel</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="reserveHoney in optionsReserveHoney" :key="reserveHoney.value" style="width:auto;">
                    <input type="radio" v-model="infoform.reserve_honey" :id="reserveHoney.value" :value="reserveHoney.value">
                    <label class="btn" :for="reserveHoney.value">{{reserveHoney.text}}</label>
                </div>
            </div>

            <b>Reserva de Polen</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="reservePollen in optionsReservePollen" :key="reservePollen.value" style="width:auto;">
                    <input type="radio" v-model="infoform.reserve_pollen" :id="reservePollen.value" :value="reservePollen.value">
                    <label class="btn" :for="reservePollen.value">{{reservePollen.text}}</label>
                </div>
            </div>
            <br>

            <div class="vsm-header">
                LÁMINAS SIN ESTIRAR
            </div>
            <br>
            <v-select
                    v-model="infoform.unstretched_sheets"
                    class="form-group subcheck"
                    color="amber darken-2"
                    :items="frames"
                    label="Láminas sin estirar"
            ></v-select>



            <!--
                        <div class="row">
                            <div class="col-d-8">
                                <b>Cuadros con miel en cámara</b>
                            </div>
                            <div class="col-d-2">

                                <v-switch
                                        color="amber darken-2"
                                        v-model="infoform.frame_with_honey"
                                        inset
                                ></v-switch>

                            </div>
                            <div class="col-d-2">
                                <v-select
                                        v-model="infoform.frame_with_honey_number"
                                        class="form-group subcheck"
                                        color="amber darken-2"
                                        :items="frames"
                                ></v-select>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-d-8">
                                <b>Cuadros con miel en alzas</b>
                            </div>
                            <div class="col-d-2">

                                <v-switch
                                        color="amber darken-2"
                                        v-model="infoform.frame_with_hikes"
                                        inset
                                ></v-switch>

                            </div>
                            <div class="col-d-2">
                                <v-select
                                        v-model="infoform.frame_with_hikes_number"
                                        class="form-group subcheck"
                                        color="amber darken-2"
                                        :items="frames"
                                ></v-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-d-8">
                                <b>Cuadros con polen</b>
                            </div>
                            <div class="col-d-2">

                                <v-switch
                                        color="amber darken-2"
                                        v-model="infoform.frame_with_pollen"
                                        inset
                                ></v-switch>

                            </div>
                            <div class="col-d-2">
                                <v-select
                                        v-model="infoform.frame_with_pollen_number"
                                        class="form-group subcheck"
                                        color="amber darken-2"
                                        :items="frames"
                                ></v-select>
                            </div>
                        </div>

            -->
            <div class="vsm-header">
                CRÍA
            </div>

            <div class="row">
                <div class="col-d-10">
                    <b>Huevos</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.cria_eggs"
                            inset
                    ></v-switch>

                </div>
                <!--div class="col-d-2">
                    <v-select
                            v-model="infoform.cria_eggs_number"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="frames"
                    ></v-select>
                </div-->
            </div>

            <!--div class="row">
                <div class="col-d-8">
                    <b>Larvas</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.cria_larvae"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-2">
                    <v-select
                            v-model="infoform.cria_larvae_number"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="frames"
                    ></v-select>
                </div>
            </div>

            <div class="row">
                <div class="col-d-8">
                    <b>Operculada</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.cria_capped"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-2">
                    <v-select
                            v-model="infoform.cria_capped_number"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="frames"
                    ></v-select>
                </div>
            </div-->


            <b>Patrón de puesta</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="cria_laying_pattern in optionsLayingPattern" :key="cria_laying_pattern.value" style="width:auto;">
                    <input type="radio" v-model="infoform.cria_laying_pattern" :id="cria_laying_pattern.value" :value="cria_laying_pattern.value">
                    <label class="btn" :for="cria_laying_pattern.value">{{cria_laying_pattern.text}}</label>
                </div>
            </div>

            <b>Mosaico</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="mosaic in optionsMosaic" :key="mosaic.value" style="width:auto">
                    <input type="radio" v-model="infoform.mosaic" :id="mosaic.value" :value="mosaic.value">
                    <label class="btn" :for="mosaic.value">{{mosaic.text}}</label>
                </div>
            </div>

            <div class="vsm-header">
                REINA
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Realeras</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.queen_royal"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-select
                            v-model="infoform.queen_royal_value"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="optionsRoyalsQueen"
                    ></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-d-4">
                    <b>Reina vista</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.queen_view"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-text-field
                            v-model="infoform.queen_view_info"
                            class="subcheck"
                            color="orange"
                            placeholder="aspecto, talla..."
                    ></v-text-field>
                </div>
            </div>

            <!--div class="row">
                <div class="col-d-4">
                    <b>Sin reina</b>
                </div>
                <div class="col-d-8">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.queen_no"
                            inset
                    ></v-switch>

                </div>

            </div-->
            <div class="vsm-header">
                ZÁNGANOS
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Celda de zánganos</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.drone_cells"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-text-field
                            v-model="infoform.drone_cells_info"
                            class="subcheck"
                            color="orange"
                            placeholder="información..."
                    ></v-text-field>
                </div>
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Zánganos</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.drone"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-text-field
                            v-model="infoform.drone_info"
                            class="subcheck"
                            color="orange"
                            placeholder="normal, en exceso..."
                    ></v-text-field>
                </div>
            </div>

            <div class="vsm-header">
                ENFERMEDAD/PLAGA
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Enfermedad</b>
                </div>

                <div class="col-d-8">
                    <v-select
                            v-model="infoform.disease"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="optionsDisease"
                    ></v-select>
                </div>
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Plaga</b>
                </div>
                <div class="col-d-8">
                    <v-select
                            v-model="infoform.pests"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="optionsPests"
                    ></v-select>
                </div>
            </div>

            <v-text-field
                    label="Notas enfermedades"
                    v-model="infoform.disease_others"
                    color="orange"
                    placeholder="otras enfermedades, notas..."
            ></v-text-field>




            <div class="vsm-header">
                OTROS
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Propóleo</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.propolis"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-text-field
                            v-model="infoform.propolis_info"
                            class="subcheck"
                            color="orange"
                            placeholder="excesivo..."
                    ></v-text-field>
                </div>
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Recolección polen</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.collect_pollen"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-text-field
                            v-model="infoform.collect_pollen_info"
                            class="subcheck"
                            color="orange"
                            placeholder="comentario adicional..."
                    ></v-text-field>
                </div>
            </div>

            <p><b>Notas</b></p>
            <v-col class="col" cols="12" md="5">
                <v-textarea
                        solo
                        name="notes"
                        placeholder="observaciones de la visita..."
                        v-model="infoform.notes"
                ></v-textarea>
            </v-col>

            <div class="vsm-header">
                VOLVER PRONTO PARA REVISAR
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Aviso</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.return"
                            inset
                    ></v-switch>

                </div>

            </div>

            <div class="col-d-12">
                <v-text-field
                        v-model="infoform.return_description"
                        class="subcheck"
                        color="orange"
                        placeholder="Motivo revisión..."
                ></v-text-field>
            </div>


            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>

            <p class="v-messages__message">{{errors.date}}</p>


            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Editar visita
            </v-btn>

        </v-form>




    </div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import vigor from "@/components/hive_state/vigor"
import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/dist/locale'

export default {

    name: 'visita-colmena-editar',
    components: {
        toolbar,
        loading,
        vigor,
        Datepicker
    },
    data() {
      return {


        radioGroup: 1,

        selected: 'radio1',
        options: '',


            toolbar: {
                return: '0',
                icons: [
                  { text: 'Eliminar', click:'delete', id:this.$route.params.id, method:'hive_visits' },
                  { text: 'Cancelar', href:'visita-colmena-editar/'+this.$route.params.id}
                ],

            },

            valid: true,

            isloading:'',

            es: es,

            errors: {
                date:'',
            },

            alertForm:'success',
            responseform:'',
            alert: false,

            frames: [
              { text: '0', value: '0' },
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '8', value: '8' },
              { text: '9', value: '9' },
              { text: '10', value: '10' }
            ],

            optionsSize: [
              { text: 'Grande', value: 'grande' },
              { text: 'Mediano', value: 'mediano' },
              { text: 'Pequeño', value: 'pequeño' }
            ],


            optionsCheerup: [
              { text: 'Nula', value: 'nula' },
              { text: 'Baja', value: 'baja' },
              { text: 'Media', value: 'media' },
              { text: 'Alta', value: 'alta' }
            ],

            optionsConditions: [
              { text: 'Normal', value: 'normal' },
              { text: 'Abejas muertas', value: 'muertas' },
              { text: 'Húmedas', value: 'humedas' },
              { text: 'Moho', value: 'moho' }
            ],

            optionsLayingPattern: [
              { text: 'Sólido/Uniforme', value: 'solido' },
              { text: 'Moderado', value: 'moderado' },
              { text: 'Pobre', value: 'pobre' }
            ],

            optionsRoyalsQueen: [
              { text: 'Sin celdas', value: 'sin_celdas' },
              { text: 'Enjambre', value: 'enjambre' },
              { text: 'Sustitución', value: 'sustitución' },
              { text: 'Emergencia', value: 'emergencia' }
            ],

            optionsDisease: [
              { text: 'Nada', value: 'nada' },
              { text: 'Ácaros Varroa', value: 'varroa' },
              { text: 'Nosema', value: 'nosema' },
              { text: 'Pollo escayolado', value: 'pollo_escayolado' },
              { text: 'Cría de piedra', value: 'cria' },
              { text: 'Loque americana', value: 'loque_americana' },
              { text: 'Loque europea', value: 'loque_europea' },
              { text: 'Otros', value: 'otros' }
            ],

            optionsPests: [
              { text: 'Nada', value: 'nada' },
              { text: 'Polilla de la cera', value: 'polilla' },
              { text: 'Roedores', value: 'roedores' },
              { text: 'Hormigas', value: 'hormigas' },
              { text: 'Avispas', value: 'avispas' },
              { text: 'Escarabajo de la colmena', value: 'escarabajo' },
              { text: 'Otros', value: 'otros' }
            ],

            optionsMosaic: [
              { text: 'Muy bueno', value: 'muy-bueno-m' },
              { text: 'Normal', value: 'normal-m' },
              { text: 'Pobre', value: 'pobre-m' }
            ],

            optionsReserveHoney: [
              { text: 'Muy bueno', value: 'muy-bueno-h' },
              { text: 'Normal', value: 'normal-h' },
              { text: 'Pobre', value: 'pobre-h' }
            ],


            optionsReservePollen: [
              { text: 'Muy bueno', value: 'muy-bueno-p' },
              { text: 'Normal', value: 'normal-p' },
              { text: 'Pobre', value: 'pobre-p' }
            ],

            date_now: {
                year: new Date().getFullYear(),
                month: new Date().getMonth(),
                day: new Date().getDate(),
            },

            infoform: {

                idcolmena: '',
                date: '',
                cheerup:'nula',
                conditions:'normal',
            /*    frame_with_bee:'',*/
                frame_with_bee_number:'0',
                frame_number_previous_visit:'0',
                frame_number_final:'0',

                frame_with_bee_size:'',

                reserve_honey: '',
                reserve_pollen: '',
                unstretched_sheets: '',



          /*      frame_with_honey:'',
                frame_with_honey_number:'0',
                frame_with_hikes:'',
                frame_with_hikes_number:'0',
                frame_with_pollen:'',
                frame_with_pollen_number:'0',
*/
                cria_eggs:'',
          /*      cria_eggs_number:'0',
                cria_larvae:'',
                cria_larvae_number:'0',
                cria_capped:'',
                cria_capped_number:'0',
                */
                cria_laying_pattern: 'solido',
                mosaic: 'normal-m',

                queen_royal:'',
                queen_royal_value:'sin_celdas',
                queen_view:'',
                queen_view_info:'',
              /*  queen_no: '', */

                drone_cells:'',
                drone_cells_info:'',
                drone:'',
                drone_info: '',

                disease: 'nada',
                pests: 'nada',
                disease_others: '',

                vigor:'50',

                propolis:'',
                propolis_info:'',
                collect_pollen:'',
                collect_pollen_info:'',
                notes: '',

                return:'',
                return_description:'',
            },

            info: null,
        }
  },
  created() {
  auth.getUserLogged()

    this.getTodos();
  },
  methods:{

        async getTodos(){
            var that = this
            await axios.get("https://appws.panimiel.com/new/index.php/api/hive_visits/detail/"+this.$route.params.id).then((info) => {
              that.info = info.data
              that.infoform.idcolmena = info.data.idcolmena
                that.infoform.date = info.data.date
                that.infoform.cheerup = info.data.cheerup
                that.infoform.conditions = info.data.conditions

                that.infoform.frame_number_previous_visit = info.data.frame_number_previous_visit
                that.infoform.frame_with_bee_number = info.data.frame_with_bee_number
                that.infoform.frame_number_final = info.data.frame_number_final

                that.infoform.frame_with_bee_size = info.data.frame_with_bee_size


                that.infoform.reserve_honey = info.data.reserve_honey
                that.infoform.reserve_pollen = info.data.reserve_pollen
                that.infoform.unstretched_sheets = info.data.unstretched_sheets



           /*     if(that.info.frame_with_honey === '1'){
                   that.infoform.frame_with_honey= that.info.frame_with_honey
                }
                that.infoform.frame_with_honey_number = info.data.frame_with_honey_number
                if(that.info.frame_with_hikes === '1'){
                   that.infoform.frame_with_hikes= that.info.frame_with_hikes
                }
                that.infoform.frame_with_hikes_number = info.data.frame_with_hikes_number
                if(that.info.frame_with_pollen === '1'){
                   that.infoform.frame_with_pollen= that.info.frame_with_pollen
                }
                that.infoform.frame_with_pollen_number = info.data.frame_with_pollen_number
                */


                if(that.info.cria_eggs === '1'){
                   that.infoform.cria_eggs= that.info.cria_eggs
                }



              /*  that.infoform.cria_eggs_number = info.data.cria_eggs_number
                if(that.info.cria_larvae === '1'){
                   that.infoform.cria_larvae= that.info.cria_larvae
                }
                that.infoform.cria_larvae_number = info.data.cria_larvae_number
                if(that.info.cria_capped === '1'){
                   that.infoform.cria_capped= that.info.cria_capped
                }
                that.infoform.cria_capped_number = info.data.cria_capped_number

                */


                that.infoform.cria_laying_pattern = info.data.cria_laying_pattern
                that.infoform.mosaic = info.data.mosaic

                if(that.info.queen_royal === '1'){
                   that.infoform.queen_royal= that.info.queen_royal
                }
                that.infoform.queen_royal_value = info.data.queen_royal_value
                if(that.info.queen_view === '1'){
                   that.infoform.queen_view= that.info.queen_view
                }
                that.infoform.queen_view_info = info.data.queen_view_info
              /*  if(that.info.queen_no === '1'){
                   that.infoform.queen_no= that.info.queen_no
                }
                */

                if(that.info.drone_cells === '1'){
                   that.infoform.drone_cells= that.info.drone_cells
                }
                that.infoform.drone_cells_info = info.data.drone_cells_info
                if(that.info.drone === '1'){
                   that.infoform.drone= that.info.drone
                }
                that.infoform.drone_info = info.data.drone_info

                that.infoform.disease = info.data.disease
                that.infoform.pests = info.data.pests
                that.infoform.disease_others = info.data.disease_others

                that.infoform.vigor = info.data.vigor

                if(that.info.propolis === '1'){
                   that.infoform.propolis= that.info.propolis
                }
                that.infoform.propolis_info = info.data.propolis_info
                if(that.info.collect_pollen === '1'){
                   that.infoform.collect_pollen= that.info.collect_pollen
                }
                that.infoform.collect_pollen_info = info.data.collect_pollen_info
                that.infoform.notes  = info.data.notes

                if(that.info.return === '1'){
                   that.infoform.return= that.info.return
                }

                that.infoform.return_description  = info.data.return_description


            })
        },

        validate () {

            if(this.infoform.date===''){
                this.errors.date = "Debes insertar la fecha de la inspección."
            }else{
                this.errors.date = ''
                this.alert = false
                this.isloading = true

                axios.put('https://appws.panimiel.com/new/index.php/api/hive_visits/'+this.$route.params.id, this.infoform).then((response) => {
                    this.responseform = response.data
                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true
                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible editar la inspección de la colmena.'
                    }
                     this.alert = true
                 })

            }

        }

    }

};


</script>

<style scoped lang="scss">
</style>